import { DebtStatusCode, ECashFlow } from 'models/Debt';

interface StatusInfo {
  text: string;
  color: string;
  bgColor: string;
  borderColor: string;
}

const statusMap: Record<string, { text: string; color: string; bgColor: string; borderColor: string }> = {
  [DebtStatusCode.WAITING]: {
    text: 'Đợi thu',
    color: '[var(--primaryColor500)]',
    bgColor: 'bg-[var(--sematicSuccessColor500)]',
    borderColor: 'border-[var(--sematicSuccessColor500)]',
  },
  [DebtStatusCode.WAITING_INCOME]: {
    text: 'Đợi thu',
    color: '[var(--primaryColor500)]',
    bgColor: 'bg-[var(--sematicSuccessColor500)]',
    borderColor: 'border-[var(--sematicSuccessColor500)]',
  },
  [DebtStatusCode.WAITING_OUTCOME]: {
    text: 'Phải trả',
    color: '[var(--primaryColor500)]',
    bgColor: 'bg-[var(--sematicErrorColor500)]',
    borderColor: 'border-[var(--sematicErrorColor500)]',
  },
  [DebtStatusCode.COMPLETED]: {
    text: 'Hoàn tất',
    color: '[var(--textBlack56)]',
    bgColor: 'bg-[var(--textBlack56)]',
    borderColor: 'border-[var(--textBlack56)]',
  },
  [DebtStatusCode.OVERDUE]: {
    text: 'Trễ hẹn',
    color: '[var(--sematicErrorColor500)]',
    bgColor: 'bg-[var(--sematicErrorColor500)]',
    borderColor: 'border-[var(--sematicErrorColor500)]',
  },
  [DebtStatusCode.OVERDUE_INCOME]: {
    text: 'Trễ hẹn thu',
    color: '[var(--sematicErrorColor500)]',
    bgColor: 'bg-[var(--sematicErrorColor500)]',
    borderColor: 'border-[var(--sematicErrorColor500)]',
  },
  [DebtStatusCode.OVERDUE_OUTCOME]: {
    text: 'Trễ hẹn trả',
    color: '[var(--sematicErrorColor500)]',
    bgColor: 'bg-[var(--sematicErrorColor500)]',
    borderColor: 'border-[var(--sematicErrorColor500)]',
  },
  [DebtStatusCode.REFUND]: {
    text: 'Phải trả',
    color: '[var(--primaryColor500)]',
    bgColor: 'bg-[var(--sematicErrorColor500)]',
    borderColor: 'border-[var(--sematicErrorColor500)]',
  },
  [DebtStatusCode.CONFIRMING]: {
    text: 'Đợi xác nhận',
    color: '[var(--sematicErrorColor600)]',
    bgColor: 'bg-[var(--sematicErrorColor600)]',
    borderColor: 'border-[var(--sematicErrorColor600)]',
  },
};

export const getStatusInfo = (statusCode: string, cashFlow?: string): StatusInfo => {
  const normalizedStatus =
    statusCode === DebtStatusCode.WAITING
      ? cashFlow === ECashFlow.INCOME
        ? DebtStatusCode.WAITING_INCOME
        : DebtStatusCode.WAITING_OUTCOME
      : statusCode === DebtStatusCode.COMPLETED
        ? DebtStatusCode.COMPLETED
        : statusCode === DebtStatusCode.REFUND
          ? DebtStatusCode.REFUND
          : statusCode === DebtStatusCode.CONFIRMING
            ? DebtStatusCode.CONFIRMING
            : cashFlow === ECashFlow.INCOME
              ? DebtStatusCode.OVERDUE_INCOME
              : DebtStatusCode.OVERDUE_OUTCOME;

  return statusMap[normalizedStatus] || statusMap[DebtStatusCode.WAITING_INCOME];
};

export const getViStatusName = (code: string) => {
  switch (code) {
    case 'debt-pending':
      return 'Đợi Thu';
    case 'debt-completed':
      return 'Hoàn Tất';
    case 'debt-confirming':
      return 'Đợi xác nhận';
    case 'debt-refund':
      return 'Phải trả';
    default:
      return 'Trể hẹn';
  }
};

export const getStatusMethod = (code: string) => {
  switch (code) {
    case 'CASH':
      return 'Tiền Mặt';
    case 'BANK_TRANSFER':
      return 'Chuyển Khoảng';
  }
};
export const debtStatusButton: Map<string, string> = new Map([
  ['debt-pending', 'Xác nhận thu hồi công nợ'],
  ['debt-refund', 'Xác nhận thanh toán công nợ'],
  ['debt-confirming', 'Xem chi tiết công nợ'],
  ['debt-completed', 'Xem chi tiết công nợ'],
]);
